
import { useState } from 'react';
import Hero from './components/Hero';
import Video from './components/Video';
import Promise from './components/Promise';
import Origin from './components/Origin';
import Purity from './components/Purity';
import ProcessDetail from './components/ProcessDetail';
import Value from './components/Value';
import Summary from './components/Summary';
import Quality from './components/Quality';
import ProductInfo from './components/ProductInfo';
import Purchase from './components/Purchase';
import Reviews from './components/Reviews';
import FAQ from './components/FAQ';
import Footer from './components/Footer';

export default function Home() {
  const [showCertModal, setShowCertModal] = useState(false);

  return (
    <div className="min-h-screen bg-[#FDFBF7]">
      <Hero onViewCert={() => setShowCertModal(true)} />
      <Video />
      <Promise />
      <Origin />
      <Purity />
      <ProcessDetail />
      <Value />
      <Summary />
      <Quality onViewCert={() => setShowCertModal(true)} />
      <ProductInfo />
      <Purchase />
      <Reviews />
      <FAQ />
      <Footer />

      {/* 검사성적서 모달 */}
      {showCertModal && (
        <div className="fixed inset-0 bg-black/50 flex items-center justify-center z-50 p-4" onClick={() => setShowCertModal(false)}>
          <div className="bg-white rounded-lg max-w-2xl w-full p-8 max-h-[90vh] overflow-y-auto" onClick={(e) => e.stopPropagation()}>
            <div className="flex justify-between items-center mb-6">
              <h3 className="text-2xl font-bold text-gray-900">검사성적서</h3>
              <button onClick={() => setShowCertModal(false)} className="w-8 h-8 flex items-center justify-center text-gray-500 hover:text-gray-700 cursor-pointer">
                <i className="ri-close-line text-2xl"></i>
              </button>
            </div>
            <div className="space-y-6">
              <div className="border border-gray-200 rounded-lg p-6">
                <h4 className="font-bold text-lg mb-4 text-gray-900">수질검사 성적서</h4>
                <div className="grid grid-cols-2 gap-4 text-sm">
                  <div>
                    <p className="text-gray-600">검사기관</p>
                    <p className="font-semibold text-gray-900">한국환경공단 수질검사센터</p>
                  </div>
                  <div>
                    <p className="text-gray-600">검사일자</p>
                    <p className="font-semibold text-gray-900">2024.11.15</p>
                  </div>
                  <div>
                    <p className="text-gray-600">일반세균</p>
                    <p className="font-semibold text-gray-900">불검출</p>
                  </div>
                  <div>
                    <p className="text-gray-600">대장균군</p>
                    <p className="font-semibold text-gray-900">불검출</p>
                  </div>
                  <div>
                    <p className="text-gray-600">질산성질소</p>
                    <p className="font-semibold text-gray-900">2.1 mg/L (기준: 10 이하)</p>
                  </div>
                  <div>
                    <p className="text-gray-600">pH</p>
                    <p className="font-semibold text-gray-900">7.2 (기준: 5.8~8.5)</p>
                  </div>
                </div>
                <button className="mt-4 text-[#6B4E9C] hover:text-[#5A3D8B] font-semibold text-sm flex items-center gap-2 cursor-pointer whitespace-nowrap">
                  <i className="ri-download-line"></i>
                  원문 PDF 다운로드
                </button>
              </div>

              <div className="border border-gray-200 rounded-lg p-6">
                <h4 className="font-bold text-lg mb-4 text-gray-900">잔류농약 검사 성적서</h4>
                <div className="grid grid-cols-2 gap-4 text-sm">
                  <div>
                    <p className="text-gray-600">검사기관</p>
                    <p className="font-semibold text-gray-900">한국식품안전연구원</p>
                  </div>
                  <div>
                    <p className="text-gray-600">검사일자</p>
                    <p className="font-semibold text-gray-900">2024.10.28</p>
                  </div>
                  <div className="col-span-2">
                    <p className="text-gray-600">검사항목 (320종)</p>
                    <p className="font-semibold text-gray-900">전 항목 불검출</p>
                  </div>
                </div>
                <button className="mt-4 text-[#6B4E9C] hover:text-[#5A3D8B] font-semibold text-sm flex items-center gap-2 cursor-pointer whitespace-nowrap">
                  <i className="ri-download-line"></i>
                  원문 PDF 다운로드
                </button>
              </div>

              <div className="border border-gray-200 rounded-lg p-6">
                <h4 className="font-bold text-lg mb-4 text-gray-900">미생물 검사 성적서</h4>
                <div className="grid grid-cols-2 gap-4 text-sm">
                  <div>
                    <p className="text-gray-600">검사기관</p>
                    <p className="font-semibold text-gray-900">식품안전나라 인증센터</p>
                  </div>
                  <div>
                    <p className="text-gray-600">검사일자</p>
                    <p className="font-semibold text-gray-900">2024.11.20</p>
                  </div>
                  <div>
                    <p className="text-gray-600">대장균</p>
                    <p className="font-semibold text-gray-900">음성</p>
                  </div>
                  <div>
                    <p className="text-gray-600">살모넬라</p>
                    <p className="font-semibold text-gray-900">음성</p>
                  </div>
                  <div>
                    <p className="text-gray-600">황색포도상구균</p>
                    <p className="font-semibold text-gray-900">음성</p>
                  </div>
                  <div>
                    <p className="text-gray-600">리스테리아</p>
                    <p className="font-semibold text-gray-900">음성</p>
                  </div>
                </div>
                <button className="mt-4 text-[#6B4E9C] hover:text-[#5A3D8B] font-semibold text-sm flex items-center gap-2 cursor-pointer whitespace-nowrap">
                  <i className="ri-download-line"></i>
                  원문 PDF 다운로드
                </button>
              </div>

              <div className="bg-gray-50 rounded-lg p-4 text-sm text-gray-600">
                <p className="font-semibold text-gray-900 mb-2">용어 안내</p>
                <p><strong>암반지하수:</strong> 암반층 깊숙이 위치한 대수층에서 취수한 지하수로, 자연여과 과정을 거쳐 불순물이 적고 미네랄이 풍부합니다.</p>
              </div>
            </div>
          </div>
        </div>
      )}
    </div>
  );
}
